"use client"

import { extractStateValue } from "@src/components/DefuseSDK/features/common/statusUtils"
import { ProgressSteps, type StepSize } from "@src/components/ProgressIndicator"
import { useSelector } from "@xstate/react"
import type { AnyActorRef } from "xstate"

export const HL_WITHDRAW_STAGES = [
  "withdrawing",
  "depositing",
  "complete",
] as const

export type HLWithdrawStage = (typeof HL_WITHDRAW_STAGES)[number]

export const HL_WITHDRAW_STAGE_LABELS: Record<HLWithdrawStage, string> = {
  withdrawing: "Withdrawing from Perps account",
  depositing: "Depositing into your account",
  complete: "Withdrawal complete",
}

export function getHLWithdrawStageFromState(
  stateValue: string
): HLWithdrawStage {
  if (stateValue === "completed" || stateValue === "error") return "complete"
  if (stateValue === "polling" || stateValue === "processing") {
    return "depositing"
  }
  return "withdrawing"
}

export function HLWithdrawProgressSteps({
  progressStage,
  isError = false,
  isSuccess = false,
  size,
}: {
  progressStage: HLWithdrawStage
  isError?: boolean
  isSuccess?: boolean
  size: StepSize
}) {
  return (
    <ProgressSteps
      stages={HL_WITHDRAW_STAGES}
      stageLabels={HL_WITHDRAW_STAGE_LABELS}
      displayStage={progressStage}
      displayIndex={HL_WITHDRAW_STAGES.indexOf(progressStage)}
      isError={isError}
      isSuccess={isSuccess}
      size={size}
    />
  )
}

export function HLWithdrawActorProgress({
  actorRef,
  size,
}: {
  actorRef: AnyActorRef
  size: StepSize
}) {
  const state = useSelector(actorRef, (snapshot) => snapshot)
  const stateValue = extractStateValue(state.value)

  return (
    <HLWithdrawProgressSteps
      progressStage={getHLWithdrawStageFromState(stateValue)}
      isError={stateValue === "error"}
      isSuccess={stateValue === "completed"}
      size={size}
    />
  )
}
